import { extractPathname } from "@src/store/slices/experienceBuilder/common/utils/extractPathname";

/**
 * The Navigator's label for the current preview location.
 *
 * Just the pathname while the preview is on the org's own store (`orgBase`) —
 * the common case, e.g. `/products/foo`. The full URL once it has navigated to
 * a different origin, which is only reachable by typing an http(s) URL into the
 * Navigator: path-only there would misrepresent a foreign page as one on the
 * merchant's own store.
 *
 * `orgBase` absent (org/domain unknown) keeps the path-only display rather than
 * assuming everything is foreign.
 */
export function formatNavigatorLocation(
  lastLocation: string,
  orgBase: string | undefined
): string {
  let url: URL;
  try {
    url = new URL(lastLocation);
  } catch {
    // Bare path or empty string — nothing to compare an origin against.
    return extractPathname(lastLocation);
  }

  const baseOrigin = safeOrigin(orgBase);
  return baseOrigin && url.origin !== baseOrigin ? url.href : url.pathname;
}

function safeOrigin(url: string | undefined): string | undefined {
  if (!url) {
    return undefined;
  }
  try {
    return new URL(url).origin;
  } catch {
    return undefined;
  }
}
